import { ClientInferRequest, ClientInferResponseBody } from "@ts-rest/core";

import { contract } from "#app/http/api";
import { api } from "#app/http/api";
import { ApiError } from "#shared/infra/apiError";

export type DeleteMaterialVolumetricPrice = ClientInferResponseBody<
  typeof contract.materials.deleteMaterialVolumetricPrice
>;

export type DeleteMaterialVolumetricPriceDto = ClientInferRequest<
  typeof contract.materials.deleteMaterialVolumetricPrice
>["body"];

export const deleteMaterialVolumetricPrice = async ({
  id,
  payload,
}: {
  id: string;
  payload: DeleteMaterialVolumetricPriceDto;
}): Promise<DeleteMaterialVolumetricPrice> => {
  const response = await api.materials.deleteMaterialVolumetricPrice.mutation({
    params: {
      id,
    },
    body: payload,
  });

  if (response.status === 200) {
    return response.body;
  }

  throw new ApiError("Failed to delete MaterialVolumetricPrice", response.status, response.body);
};
